import { ComboboxAndPopover } from '@/components/ui/combobox/combobox-and-popover';
import HotKeyListener from '@/components/ux/hot-key-listener';
import { HOTKEYS } from '@/lib/hotkeys';
import type { Deal } from '@/models/registry';
import { useState } from 'react';
import { DealPriorityBadge } from './deal-priority-badge';
import { DealPriorityCombobox } from './deal-priority-combobox';

export type DealPriorityComboboxPopoverProps = {
  id: Deal['id'];
  value: Deal['priority'];
  hideCopy?: boolean;
  side?: 'left' | 'right' | 'bottom' | 'top';
  align?: 'start' | 'end';
  withHotkeyListener?: boolean;
  useAbbreviation?: boolean;
  className?: string;
};

export function DealPriorityComboboxPopover({
  id,
  value,
  hideCopy = false,
  side = 'left',
  align = 'start',
  withHotkeyListener = false,
  useAbbreviation = false,
  className,
}: DealPriorityComboboxPopoverProps) {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <ComboboxAndPopover
        combobox={
          <DealPriorityCombobox
            id={id}
            afterOnChange={() => setOpen(false)}
            value={value}
          />
        }
        side={side}
        align={align}
        open={open}
        setOpen={setOpen}
      >
        <div>
          <DealPriorityBadge
            value={value}
            hideCopy={hideCopy}
            useAbbreviation={useAbbreviation}
            className={className}
          />
        </div>
      </ComboboxAndPopover>

      {withHotkeyListener && (
        <HotKeyListener
          hotkeys={HOTKEYS.DEAL_PRIORITY}
          onHotkeyPressed={() => setOpen(true)}
        />
      )}
    </div>
  );
}
